import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Loader } from 'semantic-ui-react';
import IconButton from '../IconButtons';
import { tagDelete } from 'data/actions';
import './style.css';

class FilterDropdownItem extends Component {
  render() {
    const { deleteInProgress, tag, handleTagDelete } = this.props;
    const className = "dropdown-delete-button";
    const classes = deleteInProgress ? className + " progress" : className;
    return (
      <span>
        {tag}
        <span className={classes}>
          <IconButton
              loading={deleteInProgress}
              name="trash"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                handleTagDelete(tag);
              }}/>
        </span>
        <span className="enter-prompt">press enter</span>
      </span>
    );
  }
}

const mapStateToProps = ({ scene }, ownProps) => {
  return {
    ...ownProps,
    deleteInProgress: scene.main.tagDeleteInProgress === ownProps.tag
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    handleTagDelete: (tag) => dispatch(tagDelete(tag))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FilterDropdownItem);



// WEBPACK FOOTER //
// ./src/components/FilterDropdownItem/index.js